import * as types from './mutations-types'

export const clienteCadastro = (context, payload) => {
  context.commit(types.setCadastroInicial, payload)
}

export const clienteAtualizaCadastro = (context, payload) => {
  context.commit(types.atualizaCadastroCliente, payload)
}



// WEBPACK FOOTER //
// ./src/domain/leiloes/store/actions.js